import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset to 24 hours
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-600 text-white rounded-lg p-6 shadow-lg" data-id="element-64">
      <p className="text-center text-lg font-semibold mb-3" data-id="element-65">
        ⏰ Esta oferta termina en:
      </p>
      <div className="flex justify-center gap-4" data-id="element-66">
        <div className="bg-white text-red-600 rounded-lg p-4 min-w-[80px] text-center" data-id="element-67">
          <div className="text-3xl font-bold" data-id="element-68">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <div className="text-sm" data-id="element-69">Horas</div>
        </div>
        <div className="bg-white text-red-600 rounded-lg p-4 min-w-[80px] text-center" data-id="element-70">
          <div className="text-3xl font-bold" data-id="element-71">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <div className="text-sm" data-id="element-72">Minutos</div>
        </div>
        <div className="bg-white text-red-600 rounded-lg p-4 min-w-[80px] text-center" data-id="element-73">
          <div className="text-3xl font-bold" data-id="element-74">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <div className="text-sm" data-id="element-75">Segundos</div>
        </div>
      </div>
    </div>;
}